module.exports = __webpack_public_path__ + "static/img/img-insurance-05.16ccf7e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-insurance-05.png
// module id = 6AK1
// module chunks = 1